
import Vue from 'vue';
import { VueEditor } from 'vue2-editor';
import { Avatar, Button } from '@descomplica/vue-components';
import { UserModel } from '@descomplica/dex-models';
import i18n from '@/i18n';
import { getEditorSettings, handleImageAdded } from '@/helpers/vue2editor';
import FileUpload from '@/components/files/FileUpload.vue';
import { FileModel } from '@/models/FileModel';

export default Vue.extend({
  components: {
    Avatar,
    Button,
    VueEditor,
    FileUpload,
  },
  props: {
    isSending: {
      type: Boolean,
      default: false,
    },
    hasAttempts: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: i18n.t('typeYourSolutionHere'),
    },
    user: {
      type: Object as Vue.PropType<UserModel>,
      required: true,
    },
    enableFileUpload: {
      type: Boolean,
      default: true,
    },
    isTextareaEnabled: {
      type: Boolean,
      default: false,
    },
    comment: {
      type: String,
      default: '',
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    files: {
      type: Array as Vue.PropType<FileModel[]>,
      default: () => [],
    },
    remainingAttemptsMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputValue: this.comment as String,
      isEnabled: this.isTextareaEnabled as Boolean,
      editorSettings: getEditorSettings({
        enableFileUpload: this.$props.enableFileUpload,
        onFileAttached: (file: File) => {
          this.$data.fileToUpload = file;
          this.$data.resetFileUpload = false;
        },
      }),
      fileToUpload: null,
      filesUploaded: this.files,
      resetFileUpload: false as Boolean,
      timeouts: [] as Array<number>,
    };
  },
  computed: {
    userAvatar(): String {
      return this.$store.getters.currentUserAvatar;
    },
    userName(): String {
      return this.$store.getters.currentUserName;
    },
    isValidinputValue(): Boolean {
      return this.inputValue && this.inputValue.trim().length > 3;
    },
  },
  watch: {
    isSending(newIsSending, oldIsSending) {
      if (!oldIsSending || newIsSending) return;
      if (this.isEditing) {
        this.isNotSending();
      } else {
        this.resetInputValue();
      }
    },
  },
  beforeDestroy() {
    const { clearTimeout } = window;

    this.timeouts.map((timeout) => clearTimeout(timeout));
  },
  methods: {
    updateFilesUploaded(files: FileModel[]) {
      this.filesUploaded = files;
    },
    editorFocus(): void {
      // @ts-ignore
      this.$refs.editor.quill.focus();
    },
    enableTextarea(): void {
      this.isEnabled = true;
      if (this.inputValue.length <= 0) {
        const { setTimeout } = window;

        this.timeouts.push(setTimeout(this.editorFocus, 100));
      }
    },
    disableTextarea(): void {
      if (!this.isValidinputValue) {
        this.isEnabled = false;
      }
    },
    onHandlerSubmit(): void {
      this.$emit('onSubmit', { text: this.inputValue, files: this.filesUploaded });
    },
    resetInputValue(): void {
      this.inputValue = '';
      this.resetFileUpload = true;
      this.disableTextarea();
    },
    isNotSending() {
      this.$emit('isNotSending');
    },
    async handleImageAdded(file: File, Editor: any, cursorLocation: any, resetUploader: Function) {
      handleImageAdded(file, Editor, cursorLocation, resetUploader, this.user.id);
    },
  },
});
